// Copyright (c) Mysten Labs, Inc.
// Modifications Copyright (c) 2024 IOTA Stiftung
// SPDX-License-Identifier: Apache-2.0

export const styleDataAttributeName = 'data-dapp-kit';

export const styleDataAttributeSelector = `[${styleDataAttributeName}]`;

export const styleDataAttribute = { [styleDataAttributeName]: '' };
